import { AutocompleteRenderOptionState } from '@mui/material';
import DriverProfile from '../DriverProfile';
import { DriverDtoModelType } from '../../../store/mst/models';
import { ListItem } from '@routific/hive';

interface Props {
  driver: DriverDtoModelType;
  props: React.HTMLAttributes<HTMLLIElement> & { key: any };
  state: AutocompleteRenderOptionState;
}

const DriverListItem: React.FC<Props> = ({ driver, props, state }) => {
  const { key, ...optionProps } = props;
  return (
    <ListItem
      props={optionProps}
      label={driver.name ?? ''}
      selected={state.selected}
      testId={`driver-selection-list-id-${key}`}
    >
      <DriverProfile driverName={driver.name} avatarSize="small" deleted={driver.deleted ?? false} />
    </ListItem>
  );
};

export default DriverListItem;
